export default __webpack_public_path__ + "static/media/outer-corners-rounded-3.bef16eb0.webp";